import React, { useState, useEffect, useRef } from "react";
import { useUser, fetchWithAuth } from "../../Context/UserContext";
import PageLayout from "../../components/layout/PageLayout";
import { TopProgressBar } from "../../components/ui/progress-bar";
import FiltroPostulaciones from "./FiltroPostulaciones";
import InfoPostulaciones from "./InfoPostulaciones";
import { LoadingOverlay } from "../../components/ui/loading-overlay";
import API_URL from "../../config";
import { Helmet } from "react-helmet-async";

const AdminPostulaciones = () => {
  const { user } = useUser();
  const [applications, setApplications] = useState([]);
  const [tenders, setTenders] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [allTenders, setAllTenders] = useState([]); // 🔹 Almacena todas las licitaciones
  const [allCompanies, setAllCompanies] = useState([]); // 🔹 Almacena todas las empresas
  const [allApplications, setAllApplications] = useState([]); // 🔹 Almacena todas las postulaciones

  const [filters, setFilters] = useState({
    id_application: [], // 🔹 Agregado nuevo filtro
    id_tender: [],
    id_licitador: [],
    estado: [],
    fecha: "",
  });

  const prevFilters = useRef(null); // 🔹 Inicializamos como null para detectar la primera ejecución
  const isFirstRender = useRef(true); // 🔹 Para rastrear la primera ejecución

  useEffect(() => {
    console.log(user);
    if (!user) return; // Si no hay usuario, no ejecutar

    // Ejecutar `fetchApplications` solo en el primer render o cuando cambien los filtros
    if (
      isFirstRender.current ||
      JSON.stringify(prevFilters.current) !== JSON.stringify(filters)
    ) {
      isFirstRender.current = false; // 🔹 Marcamos que ya no es la primera ejecución
      prevFilters.current = filters; // 🔹 Actualizamos los filtros anteriores
      fetchApplications(page, filters);
    }
  }, [page, filters, user?.user.id_user]);

  const fetchApplications = async (page, filters) => {
    setIsLoading(true);

    try {
      const params = new URLSearchParams({
        page,
        ...(filters.id_application.length > 0 && {
          id_application: filters.id_application.join(","),
        }), // 🔹 Nuevo filtro añadido
        ...(filters.estado.length > 0 && { estado: filters.estado.join(",") }),
        ...(filters.id_tender.length > 0 && {
          id_tender: filters.id_tender.join(","),
        }),
        ...(filters.id_licitador.length > 0 && {
          id_licitador: filters.id_licitador.join(","),
        }),

        ...(filters.fecha && { fecha: filters.fecha }),
      });

      const response = await fetchWithAuth(
        `${API_URL}/licit/get_applications?${params.toString()}`
      );

      if (response.ok) {
        const { applications, pages, tenders, companies } =
          await response.json();

        console.log("applications", applications);
        console.log("tenders", tenders);
        console.log("companies", companies);
        // 🔹 Extraer los ID de las aplicaciones antes de almacenarlos
        const extractedApplicationIds = applications.map((app) => ({
          id_application: app.id_application,
        }));

        // 🔹 Guardamos los filtros originales solo la primera vez
        if (allTenders.length === 0) setAllTenders(tenders);
        if (allCompanies.length === 0) {
          setAllCompanies(companies); // 🔹 Usamos los datos procesados en el backend
        }
        if (allApplications.length === 0) {
          setAllApplications(extractedApplicationIds); // 🔹 Guardar las postulaciones originales
        }

        setApplications(applications);
        setTotalPages(pages);
        setTenders(tenders);
        setCompanies(companies);
      } else {
        console.error("Error al obtener las postulaciones");
      }
    } catch (error) {
      console.error("Error al obtener las postulaciones", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageLayout>
      <Helmet>
        <title>Administrar Postulaciones - Procu</title>
        <meta
          name="description"
          content="Gestiona y revisa todas tus postulaciones a licitaciones en Procu. Encuentra oportunidades y accede a nuevos contratos en nuestra plataforma B2B."
        />
        <meta name="keywords" content="postulaciones, administración, licitaciones, negocios, contratos, proveedores, Procu, B2B" />
      </Helmet>
      <TopProgressBar isLoading={isLoading} />

      {isLoading ? (
        <LoadingOverlay />
      ) : (
        <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
          <FiltroPostulaciones
            filters={filters}
            setFilters={setFilters}
            applications={allApplications || []} // 🔹 Pasamos los filtros originales
            tenders={allTenders || []} // 🔹 Pasamos los filtros originales
            companies={allCompanies || []} // 🔹 Pasamos los filtros originales
            onClearFilters={() => {
              setFilters((prevFilters) => {
                const clearedFilters = {};
                Object.keys(prevFilters).forEach((key) => {
                  clearedFilters[key] = Array.isArray(prevFilters[key])
                    ? []
                    : "";
                });
                return clearedFilters;
              });

              // Volver a cargar todas las postulaciones sin filtros activos
              fetchApplications(1, (allFilters) => ({
                ...allFilters,
                id_application: [],
                id_tender: [],
                id_licitador: [],
                estado: [],
                fecha: "",
              }));
            }}
          />

          <InfoPostulaciones
            applications={applications}
            page={page}
            totalPages={totalPages}
            setPage={setPage}
          />
        </div>
      )}
    </PageLayout>
  );
};

export default AdminPostulaciones;
